module.exports = __webpack_public_path__ + "static/media/mascotes@2x.7a8feff0.jpg";